import { DialogActions } from '@mui/material';
import React from 'react';

const CustomDialogActions = ({ children }) => (
    <DialogActions
      sx={{
        justifyContent: "space-between",
        px: 3,
      }}
    >
      {children}
    </DialogActions>
  );

  export default CustomDialogActions;